export default class NotificationService {
  constructor (baseUrl) {
    this.xhttp = new XMLHttpRequest()
    this.baseUrl = baseUrl
  }

  getNotifications (serviceName, pageId) {
    return new Promise((resolve, reject) => {
      this.xhttp.open('GET', `${this.baseUrl}${serviceName}${'?pageSlug='}${pageId}`, true)
      this.xhttp.onload = () => {
        return resolve(this.xhttp.response)
      }
      this.xhttp.onerror = () => {
        return reject(this.xhttp.response)
      }
      this.xhttp.send()
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/NotificationService.js